/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react';
import React from 'react';

import { useMantineTheme } from '@mantine/core';
import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../../../hooks/useTypeSelector';
import { SetNotificationAction } from '../../../../redux/actions/notificationAction';
import { stateNotificationsEnum } from '../../../Utils/notification';
import { globalEnv } from '../../../../config/baseConfig';
import {
	dropzoneChildren,
	uploadFilesAndGetLocation,
	IFile,
	IUploadFile,
	readImages,
	uploadStateValues
} from '../../../Utils/upload/uploadImagesUtils';
import SaveButton from '../../../Utils/saveButton';
import { axiosInstance } from '../../../../config/axiosInstance';

type TopicProps = {
	setModalOpen: (isOpen: boolean) => void;
	topicName: string;
	topicId: string;
	imageId: string;

	isChanged: boolean;
	setIsChanged: (isChanged: boolean) => void;
	setIsWarnModalOpen: (isOpen: boolean) => void;
	setUrl: (url: string) => void;
	clearCrop: () => void;
};

export function AddSingleImageModalContent(props: TopicProps) {
	const cancelButtonRef = useRef(null);

	const theme = useMantineTheme();
	const [uploadImages, setUploadImages] = useState<IFile[]>([]);
	const [uploadFiles, setUploadFiles] = useState<IUploadFile[]>([]);

	const dispatch = useDispatch();

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const upload = async () => {
		const uploadedFiles = await uploadFilesAndGetLocation(
			uploadImages,
			setUploadImages,
			uploadFiles,
			props.topicName
		);

		let uploadState = '';

		if (uploadedFiles.length == uploadImages.length) {
			console.log('change uploadState success');
			uploadState = uploadStateValues.SUCCESS;
		} else if (uploadedFiles.length === 0) {
			uploadState = uploadStateValues.FAILED;
		} else uploadState = uploadStateValues.PARTIAL;

		if (uploadState === uploadStateValues.FAILED) throw Error('something');

		// props.setImage(uploadedFiles[0].url);
		props.setUrl(uploadedFiles[0].url);
		props.clearCrop();

		const dto = {
			topicId: props.topicId,
			imageId: props.imageId,
			url: uploadedFiles[0].url,
			url_low_res: uploadedFiles[0].url_low_res
		};

		const { data: response } = await axiosInstance.put(
			globalEnv.BASE_URL + '/editor/topic/update-image-url',
			dto,
			{
				headers: {
					Authorization: 'Bearer ' + ACCESS_TOKEN
				}
			}
		);
		return { response: response, uploadState: uploadState };
	};

	useEffect(() => {
		return () => {
			console.log('Unmount!');
		};
	}, []);

	useEffect(() => {
		uploadImages.length > 0
			? props.setIsChanged(true)
			: props.setIsChanged(false);
	}, [uploadImages]);

	const { mutate, isLoading } = useMutation(upload, {
		onSuccess: (data) => {
			data.uploadState === uploadStateValues.SUCCESS
				? dispatch(
						SetNotificationAction({
							type: stateNotificationsEnum.SUCCESS,
							message: 'Successfully updated topic info.'
						})
				  )
				: dispatch(
						SetNotificationAction({
							type: stateNotificationsEnum.WARN,
							message: "Couldn't upload all images."
						})
				  );
			props.setIsChanged(false);
			props.setModalOpen(false);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: 'Failed to update topic.'
				})
			);
		}
	});

	return (
		<div
			className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
					 w-4/6 h-full md:h-auto ml-8 px-4 py-2 max-h-[80%] mt-10 flex flex-col"
		>
			<section
				className="relative bg-gray-300 w-full max-h-screen overflow-y-auto
									dark:bg-gray-900 transition-colors duration-300 rounded-t-xl"
			>
				<div className="w-full mx-auto ">
					<div className="mx-auto px-4 w-full mt-10">
						<Dropzone
							className="dark:bg-gray-800 z-0 transition-all duration-500"
							onDrop={(files) =>
								readImages(
									uploadImages,
									setUploadImages,
									uploadFiles,
									setUploadFiles,
									files,
									1
								)
							}
							onReject={(files) => console.log('rejected files', files)}
							maxSize={30 * 1024 ** 2}
							accept={IMAGE_MIME_TYPE}
						>
							{(status) =>
								dropzoneChildren(
									uploadImages,
									status,
									theme,
									uploadFiles,
									setUploadFiles,
									setUploadImages,
									1
								)
							}
						</Dropzone>
					</div>
				</div>
			</section>
			<div
				className="flex flex-row justify-end pt-1 pb-2 px-6 space-x-2 -mt-1
						bg-gray-300 dark:bg-gray-900 shadow-lg transition-colors duration-300 rounded-b-xl"
			>
				<button
					type="button"
					className="btn btn-outline btn-sm btn-error mt-3"
					onClick={() => {
						if (props.isChanged) props.setIsWarnModalOpen(true);
						else props.setModalOpen(false);
					}}
					ref={cancelButtonRef}
				>
					Cancel
				</button>
				{props.isChanged && (
					<div className="mt-3">
						<SaveButton isSaving={isLoading} saveFunc={() => mutate()} />
					</div>
				)}
			</div>
		</div>
	);
}
